<template>
  <header class="fs-header">
    <div class="fs-header-inner">
      <button type="button" class="fs-brand" @click="$emit('home')">
        <span class="fs-logo" aria-hidden="true">
          <svg width="40" height="40" viewBox="0 0 100 100">
            <path d="M50,5 A45,45 0 1,0 50,95 A45,45 0 1,0 50,5" fill="#4378db" />
            <path d="M30,40 L70,40 L70,70 L50,85 L30,70 Z" fill="white" />
            <path d="M40,25 L60,25 A10,10 0 0,1 60,45 L40,45 A10,10 0 0,1 40,25" fill="white" />
          </svg>
        </span>
        <span class="fs-brand-text">
          <span class="fs-brand-en">Fans Store</span>
          <span class="fs-brand-zh">粉丝商城</span>
        </span>
      </button>
      <div class="fs-header-actions">
        <div class="fs-warning">涨粉王 爆流量</div>
        <a
          class="fs-contact"
          :href="contactHref"
          :target="contactReady ? '_blank' : undefined"
          :rel="contactReady ? 'noopener noreferrer' : undefined"
          @click="onContactClick"
        >联系客服</a>
      </div>
    </div>
  </header>

  <div class="fs-notice">
    <span class="fs-notice-icon" aria-hidden="true">📢</span>
    <div class="fs-notice-roller">
      <div
        v-for="(text, idx) in notices"
        :key="idx"
        class="fs-notice-item"
        :class="{ 'fs-notice-item--active': currentNotice === idx }"
      >
        <span
          class="fs-notice-text"
          :class="{ 'fs-notice-text--marquee': currentNotice === idx }"
        >{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { getUserByRefer } from '../util/api';
import { resolveReferralContext } from '../util/deeplink';

const NOTICES = [
  '一站式提升您的全球社交影响力，服务全面覆盖Telegram、Twitter、抖音等海内外主流平台！',
  '告别账号增长缓慢的烦恼，我们专注于提供高质量、高稳定性的互动与粉丝服务！',
];

function buildTgHref(username) {
  const raw = String(username || '').trim().replace(/^@+/, '');
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  if (/^t\.me\//i.test(raw)) return `https://${raw}`;
  return `https://t.me/${raw}`;
}

export default {
  name: 'FansStoreChrome',
  emits: ['home'],
  setup() {
    const route = useRoute();
    return { route };
  },
  data() {
    return {
      notices: NOTICES,
      currentNotice: 0,
      timer: null,
      contactHref: 'javascript:void(0)',
      contactReady: false,
    };
  },
  async mounted() {
    this.timer = setInterval(() => {
      this.currentNotice = (this.currentNotice + 1) % this.notices.length;
    }, 5000);
    await this.loadFishermanContact();
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async loadFishermanContact() {
      try {
        const { referralCode } = resolveReferralContext(this.route);
        if (!referralCode) return;
        const res = await getUserByRefer(referralCode);
        const href = buildTgHref(res?.data?.username);
        if (href) {
          this.contactHref = href;
          this.contactReady = true;
        }
      } catch (e) {
        console.warn('[FansStoreChrome] 加载客服链接失败', e);
      }
    },
    onContactClick(e) {
      if (this.contactReady && this.contactHref.startsWith('http')) return;
      e.preventDefault();
      window.alert('暂未获取到客服链接，请通过推广链接访问后再试');
    },
  },
};
</script>

<style scoped>
.fs-header {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.fs-header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
}

.fs-brand {
  display: flex;
  align-items: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
  min-width: 0;
}

.fs-logo {
  display: flex;
  margin-right: 10px;
  flex-shrink: 0;
}

.fs-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.fs-brand-en {
  font-size: 24px;
  font-weight: 700;
  color: #4378db;
}

.fs-brand-zh {
  font-size: 14px;
  color: #666;
}

.fs-header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.fs-warning {
  color: #ff0000;
  font-size: 14px;
  white-space: nowrap;
}

.fs-contact {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 15px;
  background: #40a9ff;
  color: #fff;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
}

.fs-notice {
  background: #fffbe6;
  border-bottom: 1px solid #ffe58f;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
}

.fs-notice-icon {
  margin-right: 10px;
  font-size: 18px;
  flex-shrink: 0;
}

.fs-notice-roller {
  flex: 1;
  height: 24px;
  overflow: hidden;
  position: relative;
}

.fs-notice-item {
  position: absolute;
  inset: 0;
  display: none;
  align-items: center;
}

.fs-notice-item--active {
  display: flex;
}

.fs-notice-text {
  display: inline-block;
  white-space: nowrap;
  color: #e74c3c;
  font-size: 15px;
}

.fs-notice-text--marquee {
  animation: fs-marquee 18s linear infinite;
}

@keyframes fs-marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-55%); }
}

@media (max-width: 768px) {
  .fs-header-inner {
    padding: 12px 10px;
    align-items: flex-start;
  }

  .fs-brand-en {
    font-size: 20px;
  }

  .fs-notice {
    padding: 0 10px;
    height: 32px;
  }

  .fs-notice-text {
    font-size: 13px;
  }
}
</style>
